// extracted by mini-css-extract-plugin
export var sliderRange = "_ps-2";
export var sliderRoot = "_ps-0";
export var sliderThumb = "_ps-3";
export var sliderTrack = "_ps-1";